import { UrlsInput, Label, Help } from '../../input';

export const StartUrlsInput = ({ params, onChange, noLabel }) => (
  <div style={{ width: '100%', maxWidth: 600 }}>
    <UrlsInput
      label={!noLabel && 'Start URLs'}
      help="Specify where to start the crawl. If blank, defaults to the pattern domain."
      value={params.startUrls}
      onChange={(val) => onChange('startUrls', val)}
    />
  </div>
);
